export const sizes = {
   largest: 48,
   larger: 34,
   large: 30,
   regular: 24,
   medium: 20,
   small: 18,
   smallest: 14,
   input: 18,
   button: 18
}

export default sizes
